import { colors} from '@mui/material';
import { ReportTypeEnums } from '../types/referenceData/reportTypeEnums';

export const getReportColorDisplay = (reportTypeId: number) => {
    switch (reportTypeId) {
        case ReportTypeEnums.DepositReport:
            return (colors.blue[500]);
        case ReportTypeEnums.DonationReport:
        case ReportTypeEnums.DepositoryYearEndReport:
        case ReportTypeEnums.PayrollItemizationReport:
        case ReportTypeEnums.TransitionOutReport:
        case ReportTypeEnums.LateContributionReport:
            return (colors.green[600]);
        case ReportTypeEnums.BankReport:
            return (colors.teal[500]);
        case ReportTypeEnums.CreditCardReport:
        case ReportTypeEnums.ReimbursementReport:
        case ReportTypeEnums.SubvendorReport:
            return (""); //maybe no color?
        case ReportTypeEnums.DissolutionReport:
        case ReportTypeEnums.LpcPrePrimary:
        case ReportTypeEnums.LpcPreElection:
        case ReportTypeEnums.LpcYearEnd:
        case ReportTypeEnums.IEPACReport:
        case ReportTypeEnums.IEPACYearEndReport:
        case ReportTypeEnums.BallotQuestionYearEnd:
        case ReportTypeEnums.BallotQuestionDissolutionReport:
        case ReportTypeEnums.BallotQuestion60thDayReport:
        case ReportTypeEnums.BallotQuestionSep20Report:
        case ReportTypeEnums.BallotQuestionOct5Report:
        case ReportTypeEnums.BallotQuestionOct20Report:
        case ReportTypeEnums.BallotQuestionNov5Report:
        case ReportTypeEnums.BallotQuestionNov20Report:
        case ReportTypeEnums.TrainsitionInReport:
        case ReportTypeEnums.TransitionOutReport:
        case ReportTypeEnums.ExternalActivityReport:
            return (colors.orange[500]);
        default:
            return (colors.blue[500]);
    }
};